import { useScrollToTop } from '../../hooks/useScrollToTop'

export default function ScrollToTop() {
    useScrollToTop()
    return null
}
